






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { toStyleVal } from '@/utils';

@Component
export default class AxWrapper extends Vue {
  @Prop({ type: String, default: '' })
  align!: string;

  @Prop({ type: String, default: '' })
  justify!: string;

  get styleVal() {
    return toStyleVal([
      ['align-items', this.align],
      ['justify-content', this.justify]
    ]);
  }
}
